import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(authenticated)/entities/new')({
	head: () => ({
		meta: [
			{
				title: 'Alopex Health | Create New Entity',
			},
		],
	}),
});
